export default __webpack_public_path__ + "static/media/product.3a54f493.jpg";